import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { customAxiosInstanceMutator } from './custom-axios-instance';
import { DEFAULT_RECOGNISED_PERCENT } from '../constants/collateralValue';

/** The share of a vehicle's retail value Tirhelo recognises as security (finding #29, Settings > Loan). */
export interface CollateralSettings {
  recognisedPercent: number;
  modifiedBy?: string | null;
  modifiedDate?: string | null;
}
const URL = '/loan/api/v1/settings/collateral';
export const COLLATERAL_SETTINGS_KEY = [URL];

export const getCollateralSettings = (signal?: AbortSignal) =>
  customAxiosInstanceMutator<CollateralSettings>({ url: URL, method: 'GET', signal });

export const saveCollateralSettings = (settings: { recognisedPercent: number }) =>
  customAxiosInstanceMutator<CollateralSettings>({ url: URL, method: 'PUT', data: settings,
    headers: { 'Content-Type': 'application/json' } });

export const useCollateralSettings = () => useQuery({
  queryKey: COLLATERAL_SETTINGS_KEY,
  queryFn: ({ signal }) => getCollateralSettings(signal),
  staleTime: 5 * 60 * 1000,
});

/** The saved percentage, or the credit manual's 70% until it loads (or if it cannot be read). */
export const useRecognisedPercent = (): number => {
  const { data } = useCollateralSettings();
  const percent = Number(data?.recognisedPercent);
  return percent > 0 && percent <= 100 ? percent : DEFAULT_RECOGNISED_PERCENT;
};

export const useSaveCollateralSettings = () => {
  const client = useQueryClient();
  return useMutation({ mutationFn: saveCollateralSettings,
    onSuccess: saved => client.setQueryData(COLLATERAL_SETTINGS_KEY, saved) });
};
